import { lazy } from "react";

const CustomAulaVirtualStatics = lazy(() => import("./AulaVirtualStatics.js"));

export default CustomAulaVirtualStatics;
